<template>
  <v-list-group :value="expanded" class="filter__list--range">
    <v-list-tile slot="activator">
      <v-list-tile-content>
        <v-list-tile-title>{{filter.label}}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile>
      <v-layout
        row
        align-center
        >
        <v-flex
          shrink
          :style="{width: '60px'}"
          class="ml-3 mr-1"
        >
          <v-text-field
            class="mt-0 input--outline input--tiny"
            hide-details
            single-line
            outline
            type="number"
            placeholder="Min"
            v-model="min"
            :max="minMax"
            :min="filter.min"
          ></v-text-field>
        </v-flex>

        <span class="caption">to</span>

        <v-flex
          shrink
          :style="{width: '60px'}"
          class="ml-1"
        >
          <v-text-field
            class="mt-0 input--outline input--tiny"
            hide-details
            single-line
            outline
            type="number"
            placeholder="Max"
            v-model="max"
            :max="filter.max"
            :min="maxMin"
          ></v-text-field>
        </v-flex>

        <v-btn
          v-show="!isEqual"
          icon
          small
          color="primary"
          class="my-0"
          @click="go"
        >
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
          v-show="isEqual"
          icon
          small
          color="indigo"
          class="my-0"
          @click="clear"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-layout>
    </v-list-tile>
  </v-list-group>
</template>

<script>
import { isEqual, isNil, max, min, toNumber } from 'lodash/fp'

import Toggleable from '@/mixins/toggleable'

export default {
  name: 'FilterRange',
  mixins: [Toggleable],
  props: {
    filter: {
      type: Object,
      required: true
    },
    filterIndex: Number,
    value: {
      type: Object,
      default () {
        return {
          min: null,
          max: null
        }
      }
    }
  },
  data () {
    return {
      min: null,
      max: null
    }
  },
  computed: {
    minMax () { return min([this.max, this.filter.max]) },
    maxMin () { return max([this.min, this.filter.min]) },
    updateValue () {
      return {
        min: this.toNumber(this.min) || this.filter.min,
        max: this.toNumber(this.max) || this.filter.max
      }
    },
    isEqual () {
      return isEqual(this.value, this.updateValue) ||
      (this.value === null && this.min === null && this.max === null)
    }
  },
  methods: {
    go () {
      console.log('go clicked')

      if (this.isEqual) {
        console.log('no change, do nothing')
        return null
      }

      this.$emit('update', this.updateValue)
    },
    clear () {
      this.min = null
      this.max = null
      this.go()
    },
    toNumber (value) {
      return isNil(value) || !value.length
        ? null
        : toNumber(value)
    }
  }
}
</script>

<style lang="stylus">
.filter__list--range
  .v-list__group__items
    .v-list__tile
      padding: 0 !important

.input--tiny
  .v-input__control
    .v-input__slot
      padding: 0 !important

.input--tiny

  .v-input__slot
    padding: 0

  input
    padding: 0

</style>
